import { render, staticRenderFns } from "./navigationOffscreen.vue?vue&type=template&id=2ff32644&"
import script from "./navigationOffscreen.vue?vue&type=script&lang=js&"
export * from "./navigationOffscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports